
import React from 'react';
import './App.css'; 
import HomePage from './pages/HomePage';

function App() {
  return (
    <div>
      <HomePage />
    </div>
  );
}

export default App;
